

import logo from './logo.svg';
import './App.css';
import '../src/utils/Global.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './Routes/router';
import Header from './components/Header';
import Music from './pages/HeaderElements/music/Music';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MusicPlayer from './components/MusicPlayer/MusicPlayer';
import { pauseMusic, stopMusic } from './Redux/actions/musicPlayerAction';

function App() {
  const [language, setLanguage] = useState("en"); // Default language
  const token = useSelector((state)=>state?.auth?.authToken);
  
  const user_subscribed_status = useSelector((state)=>state?.auth?.userData?.user_subscribed)

  const { currentTrack, isPlaying, currentTrackStatus } = useSelector((state) => state.musicPlayerDetails);
  const dispatch = useDispatch();

  const handlePause = () => {
        dispatch(pauseMusic()); // Dispatch pauseMusic action
      };
    
      const handleStop = () => {
        dispatch(stopMusic()); // Dispatch stopMusic action
      };
  return (
      <>
    <BrowserRouter>
      <Router />

    {/* Render MusicPlayer globally */}
    {currentTrack && currentTrackStatus && (
        <MusicPlayer
          track={currentTrack}
          onPause={handlePause}
          onClose={handleStop}
          token={token}
          user_subscribed_status={user_subscribed_status}
        />
      )}
    </BrowserRouter> 
    <div id="prerenderReady" style={{ display: 'none' }}></div>
    </>
  );
}

export default App;
